<template>
  <CentrisModal v-if="modalOpened" @close="closeModal" />
  <div class="smm">
    <img class="smm-img" src="../assets/images/pageSmm/shadow.png" alt="" />
    <img
      class="smm-imgMob"
      src="../assets/images/pageSmm/shadowMob.png"
      alt=""
    />
    <div class="container">
      <div class="smm__head">
        <div class="smm__head-box">
          <img
            class="smm__head-box-img"
            src="../assets/images/pageSmm/c.png"
            alt=""
          />
          <h2 class="smm__head-box-title">
            <span class="first-word">
              <p class="span-line">Выжать</p>
              Выжать
              <img
                class="sticker1"
                src="../assets/images/pageSmm/sticker1.png"
                alt=""
            /></span>
            <span
              >из соцсетей
              <img
                class="sticker2"
                src="../assets/images/pageSmm/sticker2.png"
                alt=""
            /></span>
            <span
              >максимум
              <img
                class="sticker3"
                src="../assets/images/pageSmm/sticker3.png"
                alt=""
            /></span>
          </h2>
          <CentrisBtn class="btn" @click="openModal" />
        </div>
      </div>
      <div class="smm__route" ref="route">
        <div class="smm__route_content">
          <!-- <img class="smm__route_content-img" src="../assets/images/pageSmm/route.svg" alt=""> -->
          <div
            class="circle"
            ref="circle"
            :style="{
              transform: `translate(-50%, 0%) rotateZ(${circleDeg}deg)`,
            }"
          >
            <div class="circle-content">
              <div class="circle-dot line">
                <span></span>
              </div>
              <div
                class="circle-dot"
                v-for="(item, index) in getItemsDotsList"
                :key="index"
                :style="{
                  transform: `translate(-50%, -50%) rotateZ(${getDegr(
                    index
                  )}deg)`,
                }"
              >
                <div
                  class="circle-dot-items"
                  :class="getPosition(index)"
                  @mouseover="showBox(index)"
                  @mouseleave="hideBox"
                >
                  <div class="circle-dot-items-round"></div>
                  <div
                    class="circle-dot-items-box"
                    :class="{ active: showTxt && showIndex == index }"
                    ref="routeDescr"
                    :style="{
                      transform: `translate(-30%, -180%) rotateZ(${-getDegr(
                        index
                      )}deg)`,
                    }"
                  >
                    <p class="circle-dot-items-descrBox">{{ item.txt }}</p>
                  </div>
                  <h4 class="circle-dot-items-title" v-html="item.title"></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="smm__route-descr">Маршрут действий</p>
      </div>
      <div class="smm__about">
        <div
          class="smm__about-item"
          v-for="(item, index) in smmItems"
          :key="index"
        >
          <h3 class="smm__about-item-title">{{ item.title }}</h3>
          <p class="smm__about-item-descr" v-html="item.descr"></p>
        </div>
      </div>
      <div class="smm__price">
        <h3 class="smm__price-title">стоимость пакета</h3>
        <p class="smm__price-span">от</p>
        <p
          class="smm__price-descr"
          v-intersection="counter"
          :class="{ active: count == result }"
        >
          {{ count }} 000 000
        </p>
        <p class="smm__price-sum">сум</p>
      </div>
    </div>
    <div class="wrapper">
      <div class="smm__line">
        <img
          class="smm__line-img"
          v-for="item in 10"
          :key="item"
          src="@/assets/images/logo.png"
          alt=""
        />
      </div>
    </div>
    <div class="smm__form">
      <div class="container">
        <div class="smm__form-box">
          <div class="smm__form-box-txt">
            <p class="smm__form-box-txt-descr">
              заказать <img src="../assets/images/pageSmm/fire.png" alt="" />
            </p>
            <p class="smm__form-box-txt-descr">бесплатный</p>
            <p class="smm__form-box-txt-descr">
              анализ <img src="../assets/images/pageSmm/arrow.png" alt="" />
            </p>
            <p class="smm__form-box-txt-descr">страницы</p>
          </div>
          <div class="smm__form-box-form">
            <form
              id="reg-course"
              class="modal__form"
              @submit.prevent
              @submit="sendFormData"
            >
              <div class="smm__form-box-form-input">
                <p class="smm__form-box-form-input-descr">Ваше имя</p>
                <input
                  type="text"
                  name="modal-name"
                  class="form__input"
                  required
                  autocomplete="off"
                  v-model="modalName"
                />
              </div>
              <div class="smm__form-box-form-input">
                <p class="smm__form-box-form-input-descr">номер телефона</p>
                <input
                  type="tel"
                  name="modal-tel"
                  class="form__input"
                  maxlength="17"
                  v-model="modalPhone"
                  @input="inputNumber"
                  @focus="focusNumber"
                  @blur="blurNumber"
                  required
                />
              </div>
              <div class="smm__form-box-form-input">
                <p class="smm__form-box-form-input-descr">
                  ваше имя в instagram
                </p>
                <input
                  type="text"
                  name="modal-name"
                  class="form__input"
                  v-model="modalInstagram"
                />
              </div>
              <button
                class="modal-btn"
                v-if="!submitted"
                onclick="gtag('event', 'click', {'event_category': 'form'}); return true;"
              >
                Отправить заявку
              </button>
              <button class="modal-btn-accept" v-if="submitted">
                Отправлено ✔
              </button>
            </form>
          </div>
        </div>
      </div>
      <p class="smm__form-descr">
        Оставьте заявку и наши менеджера свяжутся с вами в ближайшее время
      </p>
    </div>
    <CentrisProjects class="smm__projects" id="projects"></CentrisProjects>
  </div>
  <CentrisFooter class="smm__footer" />
  <CentrisFooterSocial class="smm__footer-social" />
</template>

<script>
import CentrisBtn from "../components/modals/CentrisBtn.vue";
import CentrisModal from "@/components/modals/CentrisModal.vue";
import CentrisProjects from "../components/CentrisProjects.vue";
import CentrisFooter from "../components/CentrisFooter.vue";
import CentrisFooterSocial from "../components/CentrisFooterSocial.vue";
import { touchstart } from "dom7";
export default {
  data() {
    return {
      animationDuration: 300,
      count: 40,
      result: 9,
      submitted: false,
      modalName: "",
      modalPhone: "",
      modalInstagram: "",
      showTxt: false,
      showIndex: 0,
      priceColor: false,
      modalOpened: false,
      viewportWidth: window.innerWidth,
      mobileViewport: false,
      smmItems: [
        {
          title: "SMM",
          descr:
            "стратегии продвижения <br> Ведение социальных сетей <br> Таргетированная реклама <br> Ситуативный контент <br> Комьюнити-менеджмент <br> копирайт отчётность",
        },
        {
          title: "PRODUCTION",
          descr:
            "Видео / фото продакшн <br> Креатив <br> Съёмка рекламы <br> Имиджевое видео для соцсетей <br> анимация",
        },
        {
          title: "INFLUENCE",
          descr: "продвижения товаров и услуг <br> через блогеров и селебрити",
        },
        {
          title: "PR ",
          descr: "Ведение корпоративных медиа <br> Мероприятия и комьюнити",
        },
      ],
      lineLogo: "logo.png",
      dotsItems: [
        {
          title: "Анализ <br> страницы",
          deg: -28,
          position: "top",
          txt: "Выявляем сильные и слабые стороны",
        },
        {
          title: "Стратегия",
          deg: -18,
          position: "bottom",
          txt: "Намечаем дальнейшие планы и действия, учитывая запросы клиента",
        },
        {
          title: "Контент <br> план",
          deg: -10,
          position: "top",
          txt: "Составляем план публикаций на месяц, в зависимости от желаемых результатов",
        },
        {
          title: "Имидж",
          deg: -2,
          position: "bottom",
          txt: "Определяем сильную сторону бренда и делаем упор на неё, оформляя страницы в едином стиле",
        },
        {
          title: "Креатив",
          deg: 5,
          position: "top",
          txt: "Реализовываем креативные идеи, с учётом популярных трендов",
        },
        {
          title: "Реклама",
          deg: 15,
          position: "bottom",
          txt: "Таргетированная реклама, которая чётко настроена именно под вашу ЦА",
        },
        {
          title: "Конверсия",
          deg: 25,
          position: "top",
          txt: "Исходя из потребностей клиента делаем конверсию сайтов, Telegram-ботов, звонков и сообщений.",
        },
      ],
      circleDeg: 0,
    };
  },
  methods: {
    counter() {
      setTimeout(() => {
        if (this.count > this.result) {
          this.count -= 1;
          this.counter();
        }
      }, this.animationDuration / this.result);
    },
    sendFormData() {
      if (
        this.modalName != "" &&
        this.modalPhone != "" &&
        this.modalPhone.length == 17
      ) {
        const formData = new FormData();
        formData.append("name", this.modalName);
        formData.append("instagram", this.modalInstagram);
        formData.append("contact", this.modalPhone);
        this.submitted = true;
        this.$store.dispatch("sendForm", formData).then((response) => {
          this.modalName = "";
          this.modalPhone = "";
          this.modalInstagram = "";
          this.submitted = true;
          setTimeout(() => {
            this.submitted = false;
            this.$emit("close");
          }, 2000);
        });
      }
    },
    inputNumber(event) {
      if (this.modalPhone.length < 5) this.modalPhone = "+998 ";
      this.modalPhone = this.modalPhone.replace(/[^+|^\d|^\s]/, "");
      const lengths = [4, 7, 11, 14];
      lengths.forEach((item) => {
        if (this.modalPhone.length == item && event.data) {
          this.modalPhone += " ";
        }
      });
    },
    focusNumber() {
      if (this.modalPhone == "") this.modalPhone = "+998 ";
    },
    blurNumber() {
      if (this.modalPhone == "+998 ") this.modalPhone = "";
    },
    showBox(index) {
      this.showIndex = index;
      this.showTxt = true;
    },
    hideBox() {
      this.showTxt = false;
    },
    openModal() {
      this.modalOpened = true;
    },
    closeModal() {
      this.modalOpened = false;
    },
    getDegr(index) {
      if (this.mobileViewport) {
        const deg = 360 / this.getItemsDotsList.length;
        return Math.floor(deg * index);
      } else {
        return this.dotsItems[index].deg;
      }
    },
    getPosition(index) {
      if (this.mobileViewport) {
        return "top";
      } else {
        return this.dotsItems[index].position;
      }
    },
    setMobileViewport() {
      const setViewport = () => {
        if (window.innerWidth <= 768 && !this.mobileViewport) {
          this.mobileViewport = true;
        } else if (window.innerWidth >= 768 && this.mobileViewport) {
          this.mobileViewport = false;
        }
      };
      setViewport();
      window.addEventListener("resize", setViewport);
    },
    routeMove() {
      const route = this.$refs.route;
      // const circle = this.$refs.circle;
      // let startPointer = {
      //   mouseX: 0,
      //   mouseY: 0,
      // };
      // let currentDeg = 0;
      let timer;
      const setCircleDeg = (deg) => {
        if (deg >= 360) {
          this.circleDeg = 0;
        } else if (deg <= 0) {
          this.circleDeg = 360;
        } else {
          this.circleDeg = deg;
        }
      };
      const animate = () => {
        timer = setTimeout(() => {
          setCircleDeg(this.circleDeg - 0.02);
          animate();
        }, 5);
      };
      animate();
      // const touchMove = (e) => {
      //   let mouseX = 0;
      //   let mouseY = 0;
      //   if (e.targetTouches && e.targetTouches[0]) {
      //     e.preventDefault();
      //     const pointerEvent = e.targetTouches[0];
      //     mouseX = pointerEvent.pageX;
      //     mouseY = pointerEvent.pageY;
      //   } else {
      //     mouseX = e.clientX;
      //     mouseY = e.clientY;
      //   }
      //   const newDeg = (startPointer.mouseX - mouseX) / route.clientWidth;
      //   // if (startPageYOffset - window.pageYOffset == 0) {
      //   window.scrollTo(0, window.pageYOffset + (startPointer.mouseY - mouseY));
      //   setCircleDeg(this.circleDeg + (currentDeg - newDeg) * 50);
      //   // }
      //   currentDeg = newDeg;
      // };
      const touchEnd = (e) => {
        // route.removeEventListener("touchmove", touchMove);
        route.removeEventListener("touchend", touchEnd);
        animate();
      };
      const touchStart = (e) => {
        // e.preventDefault();
        // if (e.targetTouches && e.targetTouches[0]) {
        //   startPointer.mouseX = e.targetTouches[0].pageX;
        //   startPointer.mouseY = e.targetTouches[0].pageY;
        // } else {
        //   startPointer.mouseX = e.clientX;
        //   startPointer.mouseY = e.clientY;
        // }
        // currentDeg = 0;
        clearTimeout(timer);
        // route.addEventListener("touchmove", touchMove);
        route.addEventListener("touchend", touchEnd);
      };
      if (this.mobileViewport) {
        route.addEventListener("touchstart", touchStart);
        animate();
      } else {
        route.removeEventListener("touchstart", touchStart);
        // route.removeEventListener("touchmove", touchMove);
        route.removeEventListener("touchend", touchEnd);
        clearTimeout(timer);
      }
    },
  },
  computed: {
    getItemsDotsList() {
      if (this.mobileViewport) {
        return [...this.dotsItems, ...this.dotsItems];
      } else {
        return this.dotsItems;
      }
    },
  },
  mounted() {
    this.setMobileViewport();
    this.routeMove();
  },
  components: {
    CentrisBtn,
    CentrisModal,
    CentrisProjects,
    CentrisFooter,
    CentrisFooterSocial,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.btn {
  margin-top: 100px;
}
.smm {
  width: 100%;
  margin: -70px auto 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  &-img {
    position: absolute;
    top: 0;
    right: 0;
    @media (max-width: 768px) {
      display: none;
    }
  }
  &-imgMob {
    display: none;
    @media (max-width: 768px) {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &__head {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
      @include adaptivHeightmd(1000, 500);
    }
    &-box {
      width: 70%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        width: 100%;
      }
      &-img {
        @include adaptivWidthLg(90, 50);
        @include adaptivMarginlg(40, 0, 0, 20, 20, 0, 0, 10);
        margin-right: auto;
        @media (max-width: 768px) {
          @include adaptivWidthmd(60, 25);
          @include adaptivMarginmd(40, 0, 0, 20, 15, 0, 0, 10);
          margin-right: auto;
        }
      }
      &-title {
        margin: 0 auto;
        color: #fff;
        @include adaptiv-fontlg(110, 58);
        @include adaptiv-lineHeightlg(130, 78);
        font-family: "NF-bold";
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        @media (max-width: 768px) {
          @include adaptiv-fontmd(63, 27);
          @include adaptiv-lineHeightmd(78, 35);
        }
        span {
          width: 100%;
          color: #fff;
          -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
          clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
          transform: translateY(50px);
          opacity: 0;
          animation-name: titleAnimation;
          animation-timing-function: ease;
          animation-duration: 1.5s;
          animation-delay: 0.6s;
          -webkit-animation-fill-mode: forwards;
          float: left;
          &:first-child {
            animation-delay: 0.6s;
          }
          &:last-child {
            color: #fff;
            animation-delay: 0.7s;
          }
          @media (max-width: 768px) {
            opacity: 0;
            animation-name: titleAnimation;
            animation-timing-function: ease;
            animation-duration: 1.5s;
            animation-delay: 0.6s;
            -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 20%);
            clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 20%);
          }
        }
      }
    }
    .first-word {
      position: relative;
    }
    .span-line {
      max-width: max-content;
      background: #d9fd51;
      position: absolute;
      z-index: 1;
      color: #262626;
      font-family: "SovMod";
      transform: rotate(-2deg) scaleY(1) translateY(10px);
      animation: headLine 2.2s normal;
      @include adaptiv-fontlg(110, 60);
      @include adaptiv-lineHeightlg(110, 60);
      @include adaptivPaddinglg(5, 5, 0, 0, 5, 5, 0, 0);
      overflow: hidden;
      @media (max-width: 768px) {
        transform: rotate(-2deg) scaleY(1) translateY(3px);
        animation: headLineMob 3s normal;
        @include adaptiv-fontmd(63, 27);
        @include adaptiv-lineHeightmd(68, 30);
      }
    }
    .sticker1 {
      @include adaptivWidthLg(285, 150);
      @include adaptivHeightlg(92, 50);
      @include adaptivMarginlg(50, 0, 0, 0, 20, 0, 0, 0);
      @media (max-width: 768px) {
        @include adaptivWidthmd(180, 80);
        @include adaptivHeightmd(60, 30);
        @include adaptivMarginmd(30, 0, 0, 0, 20, 0, 0, 0);
      }
    }
    .sticker2 {
      @include adaptivWidthLg(113, 70);
      @include adaptivHeightlg(113, 70);
      animation: sticker2 1.5s linear infinite;
      @media (max-width: 768px) {
        @include adaptivWidthmd(80, 30);
        @include adaptivHeightmd(80, 30);
      }
    }
    .sticker3 {
      @include adaptivWidthLg(236, 130);
      @include adaptivHeightlg(78, 45);
      @media (max-width: 768px) {
        @include adaptivWidthmd(140, 70);
        @include adaptivHeightmd(50, 30);
      }
    }
  }
  &__route {
    width: 100%;
    // border: 2px solid white;
    @include adaptivHeightlg(700, 500);
    position: relative;
    @media (max-width: 768px) {
      @include adaptivHeightmd(600, 300);
    }
    &_content {
      position: absolute;
      top: 0;
      left: 50%;
      width: 100vw;
      height: 100%;
      transform: translate(-50%, 0%);
      overflow: hidden;
      @media (max-width: 768px) {
        transform: translate(-50%, 0%);
      }
      // &-img {
      //   display: block;
      //   width: 80%;
      //   margin: 0 auto;
      //   @media (min-width: 769px) {
      //     display: none;
      //   }
      // }
      .circle {
        position: relative;
        width: 175%;
        border: 3px solid #fff;
        border-radius: 50%;
        top: 30%;
        left: 50%;
        transform: translate(-50%, 0%) rotateZ(0deg);
        @media (max-width: 768px) {
          // display: none;
        }
        &-content {
          padding-top: 100%;
        }
        &-dot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
        &-dot.line {
          span {
            width: 3px;
            height: 20px;
            background: #fff;
            display: block;
            transform: translate(0%, -50%);
          }
        }
        &-dot {
          &-items {
            position: relative;
            &-box {
              position: absolute;
              width: 250px;
              @include adaptivWidthLg(250, 150);
              padding: 10px;
              background: #7338d8;
              border-radius: 10px;
              opacity: 0;
              transition: 0.5s;
              z-index: 99;
              @media (max-width: 768px) {
                transform: translate(-40%, -55%) rotateZ(-2deg) !important;
                @include adaptivWidthmd(350, 150);
                @include adaptivHeightmd(130, 90);
              }
              &.active {
                opacity: 1;
                transition: 0.5s;
                @media(max-width: 768px){
                  // display: none;
                }
              }
              &:after {
                content: "";
                width: 30px;
                height: 10px;
                display: block;
                background: #7338d8;
                position: absolute;
                border-radius: 100px 0px 100px;
                left: -1%;
                bottom: 0px;
                transform: rotate(-15deg);
                z-index: -1;
                @media (max-width: 768px) {
                  @include adaptivWidthmd(50, 20);
                  @include adaptivHeightmd(50, 20);
                  top: 5%;
                  left: 50%;
                  border-radius: 0px;
                  transform: translate(-50%, -50%) rotate(45deg);
                }
              }
            }
            &-descrBox {
              font-family: "Helvetica-normal";
              @include adaptiv-fontlg(20, 12);
              @include adaptiv-lineHeightlg(23, 15);
              color: #fff;
              user-select: none;
              @media (max-width: 768px) {
                @include adaptiv-fontmd(20, 12);
                @include adaptiv-lineHeightmd(23, 15);
              }
            }
            &-round {
              width: 30px;
              @include adaptivWidthLg(30, 22);
              @include adaptivHeightlg(30, 22);
              height: 30px;
              background: #fff;
              display: block;
              border-radius: 50%;
              transform: translate(0%, -50%);
              cursor: pointer;
              transition: 0.5s;
              @media (max-width: 768px) {
                width: 60px;
                @include adaptivWidthmd(50, 30);
                @include adaptivHeightmd(45, 30);
              }
              &:hover {
                background: #7338d8;
                transition: 0.5s;
                &::before {
                  background: #7338d8;
                  transition: 0.5s;
                  border: 7px solid #fff;
                }
              }
              &:before {
                content: "";
                width: 24px;
                @include adaptivWidthLg(24, 20);
                height: 24px;
                @include adaptivHeightlg(24, 20);
                background: #fff;
                border-radius: 50%;
                border: 6px solid #262626;
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                transition: 0.5s;
                @media (max-width: 768px) {
                  @include adaptivWidthmd(30, 24);
                  height: 30px;
                  @include adaptivHeightmd(25, 24);
                  border: 7px solid #262626;
                }
              }
              &:after {
                content: "";
                width: 3px;
                height: 10px;
                background: #fff;
                display: block;
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0%);
                transition: 0.5s;
                @media (max-width: 768px) {
                  width: 5px;
                  height: 12px;
                }
              }
            }
            &-title {
              font-family: "Bai Jamjuree", sans-serif;
              font-weight: 600;
              @include adaptiv-fontlg(24, 12);
              @include adaptiv-lineHeightlg(31, 19);
              color: #fff;
              text-transform: uppercase;
              text-align: center;
              position: absolute;
              left: 50%;
              transform: translate(-50%, 0%);
              z-index: 1;
              user-select: none;
              @media (max-width: 768px) {
                @include adaptiv-fontmd(25, 14);
                @include adaptiv-lineHeightmd(29, 18);
              }
            }
            &.top {
              .circle-dot-items-round {
                &:after {
                  top: -9px;
                }
              }
              .circle-dot-items-title {
                top: -100%;
                transform: translate(-50%, -100%);

              }
            }
            &.bottom {
              .circle-dot-items-round {
                &:after {
                  bottom: -9px;
                }
              }
              .circle-dot-items-title {
                bottom: 0;
                transform: translate(-50%, 100%);
              }
            }
          }
        }
      }
    }
    &-descr {
      position: absolute;
      bottom: 20%;
      right: 50%;
      transform: translate(50%, -50%);
      @include adaptiv-fontlg(15, 10);
      @include adaptiv-lineHeightlg(19, 14);
      font-family: "Bai Jamjuree", sans-serif;
      font-weight: 600;
      text-transform: uppercase;
      color: #747474;
      @media (max-width: 768px) {
        @include adaptiv-fontmd(15, 10);
      @include adaptiv-lineHeightmd(19, 14);
      bottom: 30%;
      transform: translate(50%, -50%);
      }
    }
  }
  &__about {
    @include adaptivWidthLg(940, 725);
    width: 100%;
    margin: 0 auto;
    @include adaptivPaddinglg(0, 0, 150, 150, 0, 0, 75, 75);
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @include adaptivGaplg(60, 30);
    @media (max-width: 768px) {
      @include adaptivWidthmd(550, 200);
      @include adaptivGapmd(80, 40);
      @include adaptivPaddingmd(0, 0, 60, 120, 0, 0, 30, 80);
    }
    &-item {
      width: 100%;
      display: flex;
      align-items: flex-start;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      &-title {
        width: 50%;
        @include adaptiv-fontlg(52, 30);
        @include adaptiv-lineHeightlg(52, 30);
        font-family: "Helvetica-medium";
        text-transform: uppercase;
        background: linear-gradient(90deg, #6e45e2 0%, #88d3ce 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        text-align: right;
        @include adaptivMarginlg(0, 20, 0, 0, 0, 10, 0, 0);
        @media (max-width: 768px) {
          width: 100%;
          @include adaptiv-fontmd(70, 28);
          @include adaptiv-lineHeightmd(90, 40);
          text-align: left;
        }
      }

      &-descr {
        width: 50%;
        @include adaptiv-fontlg(17, 13);
        @include adaptiv-lineHeightlg(25, 18);
        font-family: "Helvetica-medium";
        font-weight: 550;
        text-transform: uppercase;
        color: #fff;
        @media (max-width: 768px) {
          width: 100%;
          @include adaptiv-fontmd(30, 10);
          @include adaptiv-lineHeightmd(45, 16);
        }
      }
    }
  }
  &__price {
    @include adaptivPaddinglg(0, 0, 100, 150, 0, 0, 50, 75);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
      @include adaptivPaddingmd(0, 0, 75, 75, 0, 0, 30, 30);
    }
    &-title {
      @include adaptiv-fontlg(69, 35);
      @include adaptiv-lineHeightlg(83, 49);
      font-family: "Helvetica-black";
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      @media (max-width: 768px) {
        @include adaptiv-fontmd(35, 16);
        @include adaptiv-lineHeightmd(38, 19);
      }
    }
    &-span {
      @include adaptiv-fontlg(23, 15);
      @include adaptiv-lineHeightlg(23, 15);
      font-family: "Helvetica-bold";
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      @include adaptivMarginlg(0, 0, 100, 0, 0, 0, 50, 0);
      @media (max-width: 768px) {
        @include adaptiv-fontmd(10, 5);
        @include adaptiv-lineHeightmd(10, 8);
        @include adaptivMarginlg(0, 0, 30, 0, 0, 0, 15, 0);
      }
    }
    &-descr {
      width: 100%;
      @include adaptiv-fontlg(175, 90);
      @include adaptiv-lineHeightlg(220, 115);
      font-family: "Helvetica-bold";
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      @include adaptivMarginlg(0, 0, 80, 0, 0, 0, 40, 0);
      @include adaptivHeightlg(220, 115);
      position: relative;
      transition: 0.1s;
      &.active {
        animation: colorNum 2s linear normal;
      }
      @media (max-width: 768px) {
        @include adaptivHeightmd(120, 60);
        @include adaptiv-fontmd(95, 43);
        @include adaptiv-lineHeightmd(100, 53);
        @include adaptivMarginmd(0, 0, 40, 0, 0, 0, 20, 0);
      }
      &:before {
        content: "";
        display: block;
        @include adaptivWidthLg(1070, 617);
        width: 100%;
        height: 100%;
        border: 4px solid #fff;
        border-radius: 50%;
        position: absolute;
        top: -55%;
        transform: translate(20%, 50%);
        @media (max-width: 768px) {
          border: 1px solid #fff;
          @include adaptivWidthmd(600, 275);
          transform: translate(2%, 50%);
        }
      }
      &:after {
        content: "";
        display: block;
        @include adaptivWidthLg(1045, 600);
        width: 100%;
        height: 100%;
        border: 4px solid #fff;
        border-radius: 50%;
        position: absolute;
        top: -56%;
        transform: translate(23%, 50%) rotate(-4deg);
        @media (max-width: 768px) {
          border: 1px solid #fff;
          @include adaptivWidthmd(600, 275);
          transform: translate(2%, 50%) rotate(-5deg);
        }
      }
    }
    &-sum {
      @include adaptiv-fontlg(44, 22);
      @include adaptiv-lineHeightlg(50, 30);
      font-family: "Helvetica-bold";
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      @include adaptivMarginlg(0, 0, 50, 0, 0, 0, 25, 0);
      @media (max-width: 768px) {
        @include adaptiv-fontmd(20, 10);
        @include adaptiv-lineHeightmd(20, 10);
        @include adaptivMarginlg(0, 0, 50, 0, 0, 0, 25, 0);
      }
    }
  }
  .wrapper {
    width: 100%;
    @include adaptivHeightlg(200, 100);
    overflow: hidden;
  }
  &__line {
    width: 100%;
    display: flex;
    background: #2e2b2b;
    @include adaptivPaddinglg(0, 0, 20, 20, 0, 0, 10, 10);
    @include adaptivMarginlg(0, 0, 70, 0, 0, 0, 40, 0);
    transform: rotate(-2deg);
    &-img {
      @include adaptivWidthLg(280, 150);
      @include adaptivPaddinglg(35, 35, 0, 0, 15, 15, 0, 0);
      animation: logoLine 1.5s infinite linear;
    }
  }
  &__form {
    width: 100%;
    background: #7338d8;
    @include adaptivMarginlg(0, 0, 130, 0, 0, 0, 65, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
    @include adaptivPaddinglg(0, 0, 0, 20, 0, 0, 0, 10);
    &-descr {
      @include adaptiv-fontlg(16, 9);
      @include adaptiv-lineHeightlg(17, 10);
      font-family: "Helvetica-normal";
      color: #fff;
      @media (max-width: 768px) {
        @include adaptiv-fontmd(16, 9);
        @include adaptiv-lineHeightmd(17, 10);
      }
    }
    &-box {
      width: 90%;
      margin: 0 auto;
      display: flex;
      @include adaptivPaddinglg(0, 0, 65, 100, 0, 0, 35, 50);
      @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        @include adaptivPaddingmd(0, 0, 65, 100, 0, 0, 35, 50);
      }
      &-txt {
        width: 50%;
        @media (max-width: 768px) {
          width: 100%;
        }
        &-descr {
          font-family: "Helvetica-black";
          text-transform: uppercase;
          color: #fff;
          &:nth-child(1) {
            display: flex;
            align-items: flex-end;
            @include adaptiv-fontlg(57, 28);
            @include adaptiv-lineHeightlg(59, 30);
            img {
              @include adaptivWidthLg(80, 40);
            }
            @media (max-width: 768px) {
              @include adaptiv-fontmd(60, 30);
              @include adaptiv-lineHeightmd(62, 32);
            }
          }
          &:nth-child(2) {
            max-width: max-content;
            display: flex;
            align-items: flex-end;
            @include adaptiv-fontlg(88, 44);
            @include adaptiv-lineHeightlg(88, 44);
            background: #d9fd51;
            color: #3e3e3e;
            @media (max-width: 768px) {
              @include adaptiv-fontmd(78, 36);
              @include adaptiv-lineHeightmd(78, 36);
            }
          }
          &:nth-child(3) {
            display: flex;
            align-items: center;
            @include adaptiv-fontlg(88, 44);
            @include adaptiv-lineHeightlg(88, 44);
            color: #fff;
            @include adaptivMarginlg(100, 0, 0, 0, 50, 0, 0, 0);
            @media (max-width: 768px) {
              @include adaptiv-fontmd(78, 39);
              @include adaptiv-lineHeightmd(78, 39);
            }
            img {
              @include adaptivWidthLg(150, 75);
              @include adaptivHeightlg(60, 30);
              @include adaptivMarginlg(50, 0, 0, 0, 25, 0, 0, 0);
              @media (max-width: 768px) {
                display: none;
              }
            }
          }
          &:nth-child(4) {
            display: flex;
            justify-content: center;
            @include adaptivMarginlg(150, 0, 0, 0, 75, 0, 0, 0);
            @include adaptiv-fontlg(57, 28);
            @include adaptiv-lineHeightlg(59, 30);
            @media (max-width: 768px) {
              @include adaptiv-fontmd(60, 30);
              @include adaptiv-lineHeightmd(62, 32);
            }
          }
        }
      }
      &-form {
        width: 50%;
        display: flex;
        justify-content: center;
        @media (max-width: 768px) {
          width: 100%;
        }
        .modal__form {
          width: 60%;
          display: flex;
          flex-direction: column;
          align-items: center;
          @media (max-width: 768px) {
            width: 100%;
          }
        }
        .form__input {
          @include adaptivHeightlg(49, 32);
          border-radius: 11px;
          background: transparent;
          border: 1px solid #fff;
          color: #fff;
          padding: 10px;
          @include adaptiv-fontlg(15, 11);
          @include adaptiv-lineHeightlg(15, 11);
          @media (max-width: 768px) {
            @include adaptivHeightmd(60, 35);
            @include adaptiv-fontmd(20, 12);
            @include adaptiv-lineHeightmd(20, 12);
          }
        }
        .modal-btn,
        .modal-btn-accept {
          @include adaptivWidthLg(225, 130);
          width: 100%;
          @include adaptivHeightlg(49, 32);
          @include adaptivMarginlg(0, 0, 25, 0, 0, 0, 13, 0);
          // margin: 0 auto;
          border-radius: 11px;
          background: #ff6d2c;
          border: 1.5759px solid #2e2f35;
          @include adaptiv-fontlg(10, 8);
          @include adaptiv-lineHeightlg(15, 13);
          font-family: "Helvetica-medium";
          text-transform: uppercase;
          color: #fff;
          letter-spacing: 1px;
          transition: 0.5s;
          @media (max-width: 768px) {
            @include adaptivWidthmd(300, 160);
            @include adaptivHeightmd(60, 35);
            @include adaptiv-fontmd(15, 8);
            @include adaptiv-lineHeightmd(18, 13);
            letter-spacing: 1px;
          }
          &-accept {
            background: #7338d8;
            box-shadow: 2.36385px 2.36385px 0px #2e2f35;
            transition: 0.5s;
          }
          &:hover {
            box-shadow: 2.36385px 2.36385px 0px #2e2f35;
            transition: 0.5s;
          }
        }
        &-input {
          width: 100%;
          display: flex;
          flex-direction: column;
          &-descr {
            @include adaptiv-fontlg(10, 8);
            @include adaptiv-lineHeightlg(15, 13);
            font-family: "Helvetica-medium";
            text-transform: uppercase;
            color: #fff;
            @include adaptivMarginlg(0, 0, 20, 10, 0, 0, 10, 5);
            letter-spacing: 1px;
            @media (max-width: 768px) {
              @include adaptiv-fontmd(15, 8);
              @include adaptiv-lineHeightmd(18, 13);
              letter-spacing: 1px;
              @include adaptivMarginmd(0, 0, 20, 10, 0, 0, 10, 5);
            }
          }
        }
      }
    }
  }
  &__projects {
    max-width: 100%;
    background: #262626;
    .project__content-btn {
      margin-top: 60px;
    }
    .project__content-item {
      overflow: hidden;
      &:hover {
        .project__content-item_name {
          display: none;
        }
      }
    }
    .project__content-item_name {
      background: rgba(0, 0, 0, 0.788);
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background: none;
      }
    }
    .project__content-item_name-logo {
      width: 150px;
      @include adaptivWidthLg(180, 120);
      @include adaptivHeightlg(85, 60);
      overflow: hidden;
      @media (max-width: 768px) {
        @include adaptivWidthmd(220, 100);
        @include adaptivHeightmd(100, 50);
      }
    }
  }

  // keyframes ===================

  @keyframes headLine {
    0% {
      transform: rotate(0deg) scaleY(0);
    }
    60% {
      transform: rotate(0deg) scaleY(0);
    }
    90% {
      transform: rotate(0deg) scaleY(1) translateY(10px);
    }
    100% {
      transform: rotate(-2deg) scaleY(1) translateY(10px);
    }
  }
  @keyframes headLineMob {
    0% {
      transform: rotate(0deg) scaleY(0);
    }
    60% {
      transform: rotate(0deg) scaleY(0);
    }
    90% {
      transform: rotate(0deg) scaleY(1) translateY(3px);
    }
    100% {
      transform: rotate(-2deg) scaleY(1) translateY(3px);
    }
  }
  @keyframes titleAnimation {
    0% {
      transform: translateY(50px);
      opacity: 0;
      -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
      clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    }
    50% {
      transform: translateY(0);
      opacity: 1;
      -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 15%);
      clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 15%);
    }
    100% {
      transform: translateY(0);
      opacity: 1;
      -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
      clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    }
  }
  @keyframes sticker2 {
    0% {
      transform: rotate(0deg);
      transition: transform 1s;
    }
    100% {
      transform: rotate(360deg);
      transition: transform 2s;
    }
  }
  @keyframes logoLine {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0%);
    }
  }
  @keyframes colorNum {
    0% {
      color: #7338d8;
    }
    30% {
      color: #fff;
    }
    50% {
      color: #7338d8;
    }
    100% {
      color: #fff;
    }
  }
}
.smm__footer {
  max-width: 100%;
  background: url("../assets/images/pageSmm/shadow.png") no-repeat;
  background-position: top;
  background-size: cover;
  @media (max-width: 768px) {
    background-size: initial;
    background-position-y: top center;
  }
  &-social {
    max-width: 100%;
  }
}
</style>